// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2XJpZ","list":"styles_list__1fzCc"};